import { CountId, DropDownWithLabelModel } from "./dropDown";
import { SimpleAdditionalInsuranceModel } from "./additionalInsurances";

export interface SafeSeniorModel extends SimpleAdditionalInsuranceModel {
    safeSeniorCount: CountId;
}

export const SafeSeniorCountDropDown: DropDownWithLabelModel = {
    label: "Liczba seniorów",
    dropDown: [
        {
            id: CountId.one,
            displayName: "1"
        },
        {
            id: CountId.two,
            displayName: "2"
        },
        {
            id: CountId.three,
            displayName: "3"
        },
        {
            id: CountId.four,
            displayName: "4"
        }
    ]
};
